<template>
    <div class="faqitem">       
        <div class="grid grid-cols-8 gap-7 items-center border-t border-black cursor-pointer"                 
            @click="toggleArticle(index)">
            <!-- Toggle Button Column -->
            <div class="col-span-1 gap-7 flex justify-center">                
                <UiOpen class="close w-3" :class="{'open': isOpened}" :forceHover="isOpened"/>
            </div>
        
            <!-- Title Content Column -->
            <div class="col-span-7">
                <h4 class="mb-7 mt-7" v-html="article.title" :class="{'large': !small}"></h4>
            </div>
        </div>
        
        <!-- Expandable Content -->
        <div :class="{'open': isOpened, 'smalltext': small}" class="grid grid-cols-8 gap-7 content">
            <div class="col-span-1"></div> <!-- Empty space for alignment -->
            <div class="col-span-6 xsmall mb-8 py-2 content-html">
                
            <div v-html="article.contenthtml"></div>
            </div>
        </div>
    </div>
</template>

<script setup>

const UiOpen = defineAsyncComponent(() => import('@/components/ui/open.vue'));
    
    defineProps({
        article: {
            type: Object,
            required: true
        },
        small: {
            type: Boolean,
            default: false,
            required: false

        }
    });

    const isOpened = ref(false);

    const toggleArticle = (index) => {
        console.log('toggle');
        isOpened.value = !isOpened.value;
        //visibleArticles[index] = !visibleArticles[index];
    };
</script>

<style scoped>
@reference "../../assets/css/main.css";

    .content{
        max-height: 0px;
        overflow: hidden;
        transition: max-height .3s ease, opacity .3s ease;
        opacity: 0;
    }

    .content.open{
        transition: max-height 1s ease, opacity 1s .2s  ease;
        max-height: 3000px;
        opacity: 1;

    }
    @media (max-width: 768px) {
  .faqitem h4 {
    @apply text-base leading-relaxed mb-4 mt-4; /* like a <p> */
  }
}



    

</style>